import SET_UPDATE_CANDIDATE from "./setUpdatedCandidate";
import SET_REGION from "./setRegion";

export default {
    SET_UPDATE_CANDIDATE,
    SET_REGION
}